import { render, staticRenderFns } from "./Button.global.vue?vue&type=template&id=b728a9ec&scoped=true&lang=pug&"
import script from "./Button.global.vue?vue&type=script&lang=ts&"
export * from "./Button.global.vue?vue&type=script&lang=ts&"
import style0 from "./Button.global.vue?vue&type=style&index=0&id=b728a9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b728a9ec",
  null
  
)

export default component.exports